import { Badge, Card, Container, Text } from '@cottonray/ui-web'
import { SUPPORT_EMAIL } from './content'

const SETUP_STEPS = [
  'Install Easy Air Screen for Mac and open it.',
  'Put the Mac and the Android device on the same Wi-Fi network.',
  'Pick the Mac on the server screen of the Android app.',
  'Choose Extend or Mirror in macOS Display settings.',
] as const

const TROUBLESHOOTING = [
  {
    title: 'The Mac is not in the list',
    body: 'Check that both devices are on the same Wi-Fi and restart the Mac app. If discovery keeps failing, you can type the Mac IP address directly in the Android app.',
  },
  {
    title: 'The Mac screen is not coming through',
    body: 'In macOS System Settings, check that Screen Recording is allowed for Easy Air Screen, then restart the Mac app.',
  },
  {
    title: 'The picture is slow or stuttering',
    body: 'Put both devices on 5 GHz Wi-Fi if you can. Lowering the resolution in the display settings of the Android app cuts how much has to be sent.',
  },
] as const

export function EasyAirScreenSupport() {
  return (
    <>
      <section className="support-hero">
        <Container>
          <Badge tone="accent">Support</Badge>
          <Text variant="display" className="support-hero__title">
            Easy Air Screen
          </Text>
          <Text tone="muted" className="support-hero__lead">
            Setup steps and fixes for extending a Mac screen onto an Android device.
          </Text>
        </Container>
      </section>

      <section className="band band--surface">
        <Container className="support-layout">
          <div>
            <Text variant="title">Getting started</Text>
            <ol className="support-steps">
              {SETUP_STEPS.map((step) => (
                <li key={step}>
                  <Text>{step}</Text>
                </li>
              ))}
            </ol>
          </div>

          <div>
            <Text variant="title">Troubleshooting</Text>
            <div className="support-cards">
              {TROUBLESHOOTING.map((item) => (
                <Card key={item.title}>
                  <Text variant="heading">{item.title}</Text>
                  <Text tone="muted" className="support-card__body">
                    {item.body}
                  </Text>
                </Card>
              ))}
            </div>
          </div>
        </Container>
      </section>

      <section className="band band--tight">
        <Container>
          <Card raised>
            <div className="support-contact">
              <div>
                <Text variant="title">Still stuck?</Text>
                <Text tone="muted" className="support-contact__body">
                  Tell us your Mac model, your Android device, and the step where it went wrong.
                </Text>
              </div>
              <a
                className="contact__mail"
                href={`mailto:${SUPPORT_EMAIL}?subject=Easy%20Air%20Screen%20support`}
              >
                {SUPPORT_EMAIL}
              </a>
              <a href="/privacy/easy-air-screen">Privacy policy</a>
            </div>
          </Card>
        </Container>
      </section>
    </>
  )
}
